import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import BannerSliderMobile from 'components_v2/mobile/BannerSlider';
import s from './ElectionPartyWrapper.scss';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2/HeaderTab';
import InfoMsg from '../../../components/ElectionV2/common/InfoMsg/InfoMsg';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import BannerSlider from '../../desktop/BannerSlider/BannerSlider';
import {
  filterSearchSortData,
  loadYearWisePartyData,
} from '../../../routes/newslisting/redux';
import InputSearch from '../InputSearch';
import { IMAGE_URL } from '../../../constants';

class ElectionPartyWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searches: {},
      sort: {},
    };
    this.stateResultWrapRef = React.createRef();
    const { electionData } = this.props?.sectionData?.items || {};
    try {
      if (electionData) {
        const currentData = Object.values(electionData)
          .filter(e => e.partyUrl)
          .sort((a, b) => b.year - a.year)[0];
        if (currentData) {
          this.state.currentData = currentData;
        }
      }
    } catch (error) {
      //
    }
  }

  getColorClass = change => {
    if (change > 0) return s.green;
    if (change < 0) return s.red;
    return s.defaultColor; // Assuming you have a default color defined in your CSS
  };

  getChangeText = change => {
    if (change !== 0) return change > 0 ? `+${change}` : `${change}`;
    return '-';
  };

  refreshData = () => {
    const { refreshinterval } = this.props;
    if (refreshinterval && this.state?.currentData?.live) {
      this.electionWidgetInterval = setInterval(() => {
        this.props.loadAjaxPartyData(
          this.state?.currentData,
          this.state.searches,
          this.state.sort,
        );
      }, refreshinterval * 1000);
    }
  };

  componentDidMount() {
    this.refreshData();
  }

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  onTabsChange = params => {
    this.setState({ currentData: params.clickedItem });
    this.props.loadAjaxPartyData(
      params.clickedItem,
      this.state.searches,
      this.state.sort,
      true,
    );
  };

  debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  debouncedSearch = this.debounce(searches => {
    this.props.filterData(searches, this.state.sort);
  }, this.DEBOUNCE_DELAY);

  handleSearchChange = e => {
    const term = e.target.value;
    this.setState(
      {
        searches: {
          ...this.state.searches,
          'nm#an': term,
        },
      },
      () => {
        this.debouncedSearch(this.state.searches);
      },
    );
  };

  renderElection() {
    const { electionData } = this.props?.sectionData?.items || {};
    const {
      isWapView,
      winSeats,
      leadWinSeats,
      activeSeats,
      totalSeats,
      infoMsg,
      infoMsgCommon,
    } = this.props;

    return (
      <>
        <div className={s.switchTabsWrap} ref={this.stateResultWrapRef}>
          <Listingheader headingname="Parties" />
          <div className={s.tabs}>
            <span>Year :</span>{' '}
            <HeaderTab
              subSections={Object.values(electionData)
                .filter(ed => ed.partyUrl)
                .sort((a, b) => b.year - a.year)
                .map(ed => ({
                  ...ed,
                  url: ed.partyUrl,
                  link: ed.partyUrl,
                }))}
              onChangeCallback={this.onTabsChange}
            />
          </div>
        </div>
        {infoMsgCommon && (
          <div className={s.infoMsgCommon}>{infoMsgCommon}</div>
        )}
        {
          <div className={s.seatStrip}>
            <div className={s.totalSeats}>
              <div className={s.leadWins}>
                {winSeats === activeSeats ? 'Results' : 'Leads + Wins'}
              </div>:{' '}
              <span>
                {leadWinSeats}/{totalSeats}
              </span>{' '}
              {infoMsg && <InfoMsg msg={infoMsg} />}
            </div>
          </div>
        }
        <div className={s.searchBox}>
          <InputSearch
            placeholder="Search Party Name"
            searchHandler={this.handleSearchChange}
          />
        </div>
        {!isWapView &&
          this.props.filteredData &&
          Array.isArray(this.props.filteredData) &&
          this.props.filteredData.length > 0 && (
            <div className={s.partyListWrap}>
              <table>
                <thead>
                  <tr>
                    <td>Parties</td>
                    <td>{this.state?.currentData?.year}</td>
                    <td>{this.state?.currentData?.prevYear}</td>
                    <td>Change</td>
                    <td>&nbsp;</td>
                  </tr>
                </thead>
                <tbody>
                  {this.props.filteredData &&
                    Array.isArray(this.props.filteredData) &&
                    this.props.filteredData.length > 0 &&
                    this.props.filteredData.map(party => (
                      <tr>
                        <td>
                          <div className={s.partyDetailsCol}>
                            <div
                              className={s.partyFlag}
                              style={{ 'border-color': party.cc || '#84898B' }}
                            >
                              <ImageV2
                                src={
                                  party.lg
                                    ? `${IMAGE_URL}${party.lg}.cms`
                                    : `${IMAGE_URL}45963157.cms`
                                }
                                alt={party.nm}
                                placeHolderSrc={`${IMAGE_URL}45963157.cms`}
                              />
                            </div>
                            <div className={s.partyName}>{party.nm}</div>
                          </div>
                        </td>
                        <td>{party.ws + party.ls}</td>
                        <td>{party.pws}</td>
                        <td
                          className={this.getColorClass(
                            party.ws + party.ls - party.pws,
                          )}
                        >
                          {this.getChangeText(party.ws + party.ls - party.pws)}
                        </td>
                        <td>
                          <Link to="/elections/candidates">
                            {party.numcnt > 1
                              ? `${party.numcnt} Candidates`
                              : `${party.numcnt} Candidate`}
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        {isWapView &&
          this.props.filteredData &&
          Array.isArray(this.props.filteredData) &&
          this.props.filteredData.length > 0 && (
            <div className={s.partyListWrap}>
              {this.props.filteredData.map((party, index) => (
                <>
                  {index === 10 &&
                    this.props?.sectionData?.items?.banner && (
                      <div className={s.bannerSliderWrap}>
                        <BannerSliderMobile
                          key={this.props?.sectionData?.items?.banner.tn}
                          data={this.props?.sectionData?.items?.banner}
                          gaAction="ElectionBannerWidget_Click"
                          gaLabelPerfix="election_banner/click/"
                        />
                      </div>
                    )}
                  <div className={s.partyBox}>
                    <div
                      className={s.partyListTopRow}
                      style={{ 'border-color': party.cc || '#84898B' }}
                    >
                      <div
                        className={s.partyFlag}
                        style={{ 'border-color': party.cc || '#84898B' }}
                      >
                        <ImageV2
                          src={
                            party.lg
                              ? `${IMAGE_URL}${party.lg}.cms`
                              : `${IMAGE_URL}45963157.cms`
                          }
                          alt={party.nm}
                          placeHolderSrc={`${IMAGE_URL}45963157.cms`}
                        />
                      </div>
                      <div className={s.partyOtherDetails}>
                        <div className={s.partyName}>{party.nm}</div>
                        <Link to="/elections/candidates">
                          {party.numcnt > 1
                            ? `${party.numcnt} Candidates`
                            : `${party.numcnt} Candidate`}
                        </Link>
                      </div>
                    </div>
                    <div className={s.partyListBtmRow}>
                      <div className={s.partyBtmCol}>
                        <p>{this.state?.currentData?.year}</p>
                        <span>{party.ws + party.ls}</span>
                      </div>
                      <div className={s.partyBtmCol}>
                        <p>{this.state?.currentData?.prevYear}</p>
                        <span>{party.pws}</span>
                      </div>
                      <div className={s.partyBtmCol}>
                        <p>Change</p>
                        <span
                          className={this.getColorClass(
                            party.ws + party.ls - party.pws,
                          )}
                        >
                          <strong>
                            {this.getChangeText(
                              party.ws + party.ls - party.pws,
                            )}
                          </strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          )}
        {this.props.filteredData &&
          Array.isArray(this.props.filteredData) &&
          this.props.filteredData.length === 0 && (
            <div className={s.noDataBox}>
              No parties match your search criteria. Please search again!
            </div>
          )}
      </>
    );
  }

  render() {
    return (
      <div className={s.partyResultlWidgetWrapper} ref={this.ref}>
        {this.props.dataLoading && <LoaderSpinner />}
        {this.state?.currentData &&
          this.state?.currentData?.note && (
            <p className={s.noteText}>{this.state?.currentData?.note}</p>
          )}
        <div className="mt">{this.renderElection()}</div>
        {this.state?.currentData?.source && (
          <div className={`${s.sourceText} ${s.cl}`}>
            Source: {this.state?.currentData?.source}
          </div>
        )}
        {this.props?.sectionData?.items?.banner &&
          !this.props.isWapView && (
            <BannerSlider
              key={this.props?.sectionData?.items?.banner.tn}
              data={this.props?.sectionData?.items?.banner}
              gaAction="ElectionBannerWidget_Click"
              gaLabelPerfix="election_banner/click/"
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filteredData: state.newslisting && state.newslisting?.filteredData,
  fullData: state.newslisting && state.newslisting?.fullData,
  activeSeats: state.newslisting && state.newslisting?.activeSeats,
  totalSeats: state.newslisting && state.newslisting?.totalSeats,
  winSeats: state.newslisting && state.newslisting?.winSeats,
  leadWinSeats: state.newslisting && state.newslisting?.leadWinSeats,
  refreshinterval: state.newslisting && state.newslisting?.refreshinterval,
  infoMsg: state.newslisting && state.newslisting?.infoMsg,
  infoMsgCommon: state.newslisting && state.newslisting?.infoMsgCommon,
  dataLoading: state?.newslisting?.dataLoading,
});

const mapDispatchToProps = dispatch => ({
  loadAjaxPartyData: (year, searches, sort, loader = false) => {
    dispatch(loadYearWisePartyData(year, searches, sort, loader));
  },
  filterData: (searches, sort, loader = false) => {
    dispatch(filterSearchSortData(searches, sort, loader));
  },
});

ElectionPartyWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
};
ElectionPartyWrapper.defaultProps = {
  isWapView: false,
  data: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ElectionPartyWrapper,
);
